import "./news-meta.scss";

window.app.directive("newsMeta", [
  function() {
    return {
      restrict: "A",
      scope: {
        article: "&newsMeta"
      },
      template: require("./news-meta.html")
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/news-meta/news-meta.js